module.exports = __webpack_public_path__ + "img/Step6.5d77a413.png";